import React from "react";

interface DecisionMakerIconProps {
  width?: number;
  height?: number;
  fill?: string;
}

export const DecisionMakerIcon: React.FC<DecisionMakerIconProps> = ({
  width = 19,
  height = 20,
  fill = "#718392",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.833252 17.5H10.8333V19.1667H0.833252V17.5ZM4.36659 6.725L6.72492 4.36667L18.5083 16.15L16.1499 18.5083L4.36659 6.725ZM10.2666 0.833336L14.9833 5.55L12.6249 7.90834L7.90825 3.19167L10.2666 0.833336ZM3.19159 7.9L7.90825 12.6167L5.54992 14.975L0.833252 10.2583L3.19159 7.9Z"
        fill={fill}
      />
    </svg>
  );
};
